import { authHeader, config, handleError, handleResponse } from "../_helpers";

export const applicantStatsService = {
  getStatistics,
};

function getStatistics() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    config.apiUrl + "/api/stats/applicants_stats",
    requestOptions,
  ).then(handleResponse, handleError);
}
